var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43907 6.90925L9.56028 4.84865M5.43907 9.03047L9.56028 11.0911M5.68149 8.00016C5.68149 9.33904 4.59612 10.4244 3.25725 10.4244C1.91838 10.4244 0.833008 9.33904 0.833008 8.00016C0.833008 6.66129 1.91838 5.57592 3.25725 5.57592C4.59612 5.57592 5.68149 6.66129 5.68149 8.00016ZM14.1663 3.75774C14.1663 5.09661 13.081 6.18198 11.7421 6.18198C10.4032 6.18198 9.31786 5.09661 9.31786 3.75774C9.31786 2.41887 10.4032 1.3335 11.7421 1.3335C13.081 1.3335 14.1663 2.41887 14.1663 3.75774ZM14.1663 12.2426C14.1663 13.5815 13.081 14.6668 11.7421 14.6668C10.4032 14.6668 9.31786 13.5815 9.31786 12.2426C9.31786 10.9037 10.4032 9.81834 11.7421 9.81834C13.081 9.81834 14.1663 10.9037 14.1663 12.2426Z",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e9402858.svg";
export { ForwardRef as ReactComponent };